<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" :with-header="false" :before-close="closeDialog" width="75%">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <template>

        <div style="height: 65vh; overflow-y: auto;" v-if="display_data!=''">
          <el-row>
            <el-col :span="8">
              <div>
                <span>所在城市:</span>
                <span>{{ display_data.city.name }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div>
                <span>添加时间:</span>
                <span>{{ display_data.time.YmdHis }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div>
                <span>修改时间:</span>
                <span>{{ display_data.edit_time.YmdHis }}</span>
              </div>
            </el-col>
          </el-row>


          <el-row v-for="(item, index) in advert_details_arrway" :key="index" class="row">
            <el-col :span="24">

              <div style="display: flex;justify-content: space-around;">
                <div class="box-img">
                  <el-image style="width: 200px; height: 200px" :src="item.cover_img.url"></el-image>
                  <p>封面图片</p>
                </div>
                <div class="box-img">
                  <el-image style="width: 200px; height: 200px" :src="item.logo_img.url"></el-image>
                  <p>logo图片</p>
                </div>
                <div class="box-img">
                  <el-image style="width: 200px; height: 200px" :src="item.list_img.url"></el-image>
                  <p>列表图片</p>
                </div>
              </div>


              <div style="width: 50%;display: inline-block;" class="section">
                <span>链接地址:</span>
                <span>{{ item.link }}</span>
              </div>

              <div style="width: 50%;display: inline-block;" class="section">
                <span>广告名称:</span>
                <span>{{ item.name }}</span>
              </div>

              <div style="width: 50%;display: inline-block;" class="section">
                <span>开始时间:</span>
                <span>{{ display_data.synthesize[index].start_time.YmdHis }}</span>
              </div>

              <div style="width: 50%;display: inline-block;" class="section">
                <span>结束时间:</span>
                <span>{{ display_data.synthesize[index].end_time.YmdHis }}</span>
              </div>

              <div style="width: 50%;display: inline-block;" class="section">
                <span>创建时间:</span>
                <span>{{ item.time.YmdHis }}</span>
              </div>

              <div style="width: 50%;display: inline-block;" class="section">
                <span>修改时间:</span>
                <span>{{ item.edit_time.YmdHis }}</span>
              </div>

              <div class="section">
                <span>广告内容:</span>
                <div v-html="item.content" style="display: inline-block;"></div>
              </div>


              <div class="section">
                <span>备注:</span>
                <span>{{ item.remarks }}</span>
              </div>
            </el-col>
          </el-row>

        </div>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center;margin-top: 10px;">
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>

    </div>


  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.advert_details_arrway.length=0;
        _this.advertAppointDetails_arrway.length = 0;
        // 请求广告位详情
        _this.$post(
            "/advert/getAdvertAppointDetails", {
              advert_appoint_code: _this.data
            }
          )
          .then(res => {

            _this.display_data = res.data;


            for (let i = 0; i < res.data.synthesize.length; i++) {

              this.$post(
                "/advert/getAdvertDetails", {
                  advert_code: res.data.synthesize[i].advert_code
                }
              )
              .then(res => {

                this.advert_details_arrway.push(res.data);


              }).catch((err) => {

              })
            }


          }).catch((err) => {

          })


      },
    },
    data() {
      return {

        show: false,


        //显示数据
        display_data: '',

        advert_details_arrway: [],
        advertAppointDetails_arrway:[]

      };
    },
    created() {

      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;
        _this.display_data='';

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .verify_remarks {
    font-size: 14px;
    color: #606266;
  }

  .quill-editor {
    width: 80%;
  }

  .adver-list,
  .adver-selection {
    display: flex;
    flex-wrap: wrap;
    max-height: 300px;
    overflow-y: auto;
  }

  .adver-selection {
    margin-bottom: 50px;
  }

  .adver-list {
    max-height: 500px;
  }

  .adver-list h4,
  .adver-selection h4 {
    width: 100%;
  }

  .adver-list .adver,
  .adver-selection .adver {
    width: 23%;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 10px;
    margin: 10px;
    transition: .5s;
  }

  .adver-list .adver:hover,
  .adver-selection .adver:hover {
    border: 1px solid #409EFF;
    background-color: #409EFF;
  }

  .time-box {
    font-size: 14px;
    margin-top: 15px;
    display: flex;
    justify-content: space-around;
    border-top: 1px solid #ccc;
    padding: 5px 0;
  }

  .row {
    background-color: #f0f0f0;
    padding: 20px;
    box-sizing: border-box;
    margin: 20px 0;
    border-radius: 10px;
  }

  .box-img {
    width: 30%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 20px;
  }

  .box-img p {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .section {
    margin: 10px 0;
  }
</style>